import React from 'react'
import './../App.css'
import { Route, Switch, Redirect } from 'react-router-dom'
import Xr41Hull from './Xr41Hull'
import Xr41BowSprit from './Xr41BowSprit'
import Xr41HullTreatment from './Xr41HullTreatment'
import Xr41BathingLadder from './Xr41BathingLadder'
import Xr41Cockpit from './Xr41Cockpit'
import Xr41Sprayhood from './Xr41Sprayhood'
import Xr41Mainsail from './Xr41Mainsail'
import Xr41Saloon from './Xr41Saloon'
import Xr41Fabric from './Xr41Fabric'
import Xr41Galley from './Xr41Galley'
import Xr41Aftcabin from './Xr41Aftcabin'
import Xr41Head from './Xr41Head'
import Xr41Forwardcabin from './Xr41Forwardcabin'
import Xr41Transom from './Xr41Transom'
import Xr41Summary from './Xr41Summary'

import Logo from './Xr41-logo.svg'

import hullColorXr41_1 from '../assets/hullColors/9010_9005.jpg'

import fabric1 from '../assets/fabrics/JustFleckless–01Nature.jpg'
import fabric2 from '../assets/fabrics/JustFleckless–05Camel.jpg'
import fabric3 from '../assets/fabrics/JustFleckless–10Navy.jpg'
import fabric5 from '../assets/fabrics/JustFleckless–710MoonGrey.jpg'
import fabric6 from '../assets/fabrics/JustFleckless–750OliveGrey.jpg'
import fabric7 from '../assets/fabrics/AlsaceBlue.jpg'
import fabric8 from '../assets/fabrics/AlsaceIvory.jpg'
import fabric9 from '../assets/fabrics/AlsaceSand.jpg'
import fabric10 from '../assets/fabrics/Nubilux709Argent.jpg'

import sprayhood1 from '../assets/sprayhoodColors/without.jpg'
import sprayhood2 from '../assets/sprayhoodColors/Dark grey.jpg'
import sprayhood3 from '../assets/sprayhoodColors/Taupe.jpg'
import sprayhood4 from '../assets/sprayhoodColors/Captains blue.jpg'
import sprayhood5 from '../assets/sprayhoodColors/Silver grey.jpg'
import sprayhood6 from '../assets/sprayhoodColors/jetblack.jpg'

import ConfiguratorContainer from '../ConfiguratorContainer'
import { withTranslation } from 'react-i18next'

class Xr41Container extends ConfiguratorContainer {
  constructor (props) {
    super(props)

    this.logo = Logo
    this.logoLink = 'https://www.x-yachts.com/en/yachts/xracing/xr-41/'

    this.HullColourOptions = [
      {
        value: 1,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & 3 x Black (RAL 9005) integrated Gelcoat Water Lines'
        ),
        preview: hullColorXr41_1
      }
    ]

    this.BowspritOptions = [
      { value: 1, label: this.props.t('Sport with anchor') },
      { value: 2, label: this.props.t('Race') }
    ]

    this.HullTreatmentOptions = [
      { value: 1, label: this.props.t('White') },
      { value: 2, label: this.props.t('Grey') },
      { value: 3, label: this.props.t('Black') }
    ]

    this.BathingLadderOptions = [
      { value: 1, label: this.props.t('Off') },
      { value: 2, label: this.props.t('On') }
    ]

    this.CockpitLockersOptions = [
      { value: 1, label: this.props.t('None') },
      { value: 2, label: this.props.t('On') }
    ]

    this.RemovableFootChocksOptions = [
      { value: 1, label: this.props.t('None') },
      { value: 2, label: this.props.t('On') }
    ]

    this.RemovableCockpitTableOptions = [
      { value: 1, label: this.props.t('None') },
      { value: 2, label: this.props.t('On') }
    ]

    this.RemovableCompassOptions = [
      { value: 1, label: this.props.t('None') },
      { value: 2, label: this.props.t('On') }
    ]
    this.SprayhoodOptions = [
      { value: 1, label: this.props.t('Without'), thumbnail: sprayhood1 },
      { value: 2, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
      { value: 3, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
      { value: 4, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
      { value: 5, label: this.props.t('Silver grey'), thumbnail: sprayhood5 },
      { value: 6, label: this.props.t('Jet Black'), thumbnail: sprayhood6 }
    ]

    this.MastAndBoomOptions = [
      { value: 1, label: this.props.t('Black painted carbon') }
    ]

    this.BoomCoverOptions = [
      { value: 1, label: this.props.t('Without'), thumbnail: sprayhood1 },
      { value: 5, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
      { value: 3, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
      { value: 4, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
      { value: 2, label: this.props.t('Silver grey'), thumbnail: sprayhood5 },
      { value: 6, label: this.props.t('Jet Black'), thumbnail: sprayhood6 }
    ]

    this.MainsailOptions = [
      { value: 1, label: this.props.t('None') },
      { value: 2, label: this.props.t('Square top main') },
      { value: 3, label: this.props.t('Pin head main') }
    ]

    this.FlagOptions = [{ value: 1, label: this.props.t('danish YF flag') }]

    this.LayoutOptions = [
      { value: 1, label: this.props.t('Standard') },
      { value: 2, label: this.props.t('Sport') },
      { value: 3, label: this.props.t('Race') }
    ]

    this.FabricOptions = [
      {
        value: 1,
        label: this.props.t('Just Fleckless – 01 Nature'),
        thumbnail: fabric1
      },
      {
        value: 2,
        label: this.props.t('Just Fleckless – 05 Camel'),
        thumbnail: fabric2
      },
      {
        value: 3,
        label: this.props.t('Just Fleckless – 10 Navy'),
        thumbnail: fabric3
      },
      {
        value: 5,
        label: this.props.t('Just Fleckless – 710 Moon Grey'),
        thumbnail: fabric5
      },
      {
        value: 6,
        label: this.props.t('Just Fleckless – 750 Olive Grey'),
        thumbnail: fabric6
      },
      { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
      { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
      { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
      {
        value: 10,
        label: this.props.t('Nubilux 709 Argent'),
        thumbnail: fabric10
      }
    ]

    this.FabricOwnersOptions = [
      {
        value: 1,
        label: this.props.t('Just Fleckless – 01 Nature'),
        thumbnail: fabric1
      },
      {
        value: 2,
        label: this.props.t('Just Fleckless – 05 Camel'),
        thumbnail: fabric2
      },
      {
        value: 3,
        label: this.props.t('Just Fleckless – 10 Navy'),
        thumbnail: fabric3
      },
      {
        value: 5,
        label: this.props.t('Just Fleckless – 710 Moon Grey'),
        thumbnail: fabric5
      },
      {
        value: 6,
        label: this.props.t('Just Fleckless – 750 Olive Grey'),
        thumbnail: fabric6
      },
      { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
      { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
      { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
      {
        value: 10,
        label: this.props.t('Nubilux 709 Argent'),
        thumbnail: fabric10
      }
    ]

    this.state = Object.assign(this.state, {
      boat: 'Xr41',
      exterior: {
        HullColorways: this.HullColourOptions[0],
        Bowsprit: this.BowspritOptions[0],
        HullTreatment: this.HullTreatmentOptions[0],
        BathingLadder: this.BathingLadderOptions[0],
        CockpitLockers: this.CockpitLockersOptions[0],
        RemovableFootChocks: this.RemovableFootChocksOptions[0],
        RemovableCockpitTable: this.RemovableCockpitTableOptions[0],
        RemovableCompass: this.RemovableCompassOptions[0],
        Sprayhood: this.SprayhoodOptions[0],
        MastAndBoom: this.MastAndBoomOptions[0],
        BoomCover: this.BoomCoverOptions[0],
        Mainsail: this.MainsailOptions[0],
        Flag: this.FlagOptions[0]
      },
      transom: {
        Name: {
          verticalOffset: 150,
          color: this.colorOptions[3],
          value: this.props.t('My yacht'),
          font: this.fontOptions[0],
          size: this.sizeOptions[5],
          horizontalOffset: 0
        },
        Port: {
          verticalOffset: 380,
          color: this.colorOptions[3],
          value: this.props.t('Harbor'),
          font: this.fontOptions[0],
          size: this.sizeOptions[4],
          horizontalOffset: 0
        }
      },
      interior: {
        Layout: this.LayoutOptions[1],
        Fabric: this.FabricOptions[0],
        FabricOwners: this.FabricOwnersOptions[0]
      }
    })

    this.steps = [
      { name: this.props.t('Hull colourways'), url: '/xr41/hull' },
      { name: this.props.t('Bowsprit'), url: '/xr41/bowsprit' },
      { name: this.props.t('Hull treatment'), url: '/xr41/hulltreatment' },
      { name: this.props.t('Boat name'), url: '/xr41/boatname' },
      { name: this.props.t('Bathing Ladder'), url: '/xr41/bathingladder' },
      { name: this.props.t('Cockpit'), url: '/xr41/cockpit' },
      { name: this.props.t('Sprayhood & Boom cover'), url: '/xr41/sprayhood' },
      { name: this.props.t('Mainsail'), url: '/xr41/mainsail' },
      { name: this.props.t('Saloon'), url: '/xr41/saloon' },
      { name: this.props.t('Fabric'), url: '/xr41/fabric' },
      { name: this.props.t('Galley'), url: '/xr41/galley' },
      { name: this.props.t('Aft Cabins'), url: '/xr41/aftcabin' },
      { name: this.props.t('Head'), url: '/xr41/head' },
      { name: this.props.t('Forward cabin'), url: '/xr41/forwardcabin' },
      { name: this.props.t('Summary'), url: '/xr41/summary' }
    ]

    this.handleHullConfigurationChange =
      this.handleHullConfigurationChange.bind(this)
  }

  handleHullConfigurationChange (newConfiguration) {
    let transom = this.state.transom
    switch (newConfiguration.HullColorways.value) {
      case 1:
        transom.Name.color = this.colorOptions[3]
        transom.Port.color = this.colorOptions[3]
        break
      case 2:
        transom.Name.color = this.colorOptions[3]
        transom.Port.color = this.colorOptions[3]
        break
      case 3:
        transom.Name.color = this.colorOptions[1]
        transom.Port.color = this.colorOptions[1]
        break
      case 4:
        transom.Name.color = this.colorOptions[1]
        transom.Port.color = this.colorOptions[1]
        break
      case 5:
        transom.Name.color = this.colorOptions[1]
        transom.Port.color = this.colorOptions[1]
        break
      default:
        break
    }

    super.handleTransomChange(transom)
    super.handleExteriorConfigurationChange(newConfiguration)
  }

  generateCode () {
    // Xr41 code schema:
    // [ 'Xr41',
    //   [exterior...],
    //   [ [transomName...], [transomPort...] ],
    //   [interior...]
    // ]
    //
    // Exterior index order:
    // 0: HullColorways
    // 1: Bowsprit
    // 2: HullTreatment
    // 3: BathingLadder
    // 4: CockpitLockers
    // 5: RemovableFootChocks
    // 6: RemovableCockpitTable
    // 7: RemovableCompass
    // 8: Sprayhood
    // 9: MastAndBoom
    // 10: BoomCover
    // 11: Mainsail
    //
    // Interior index order:
    // 0: Layout
    // 1: Fabric
    // 2: FabricOwners

    let data = []
    data.push('Xr41')

    // Exterior options
    const exterior = this.state.exterior
    const exteriorOrder = [
      'HullColorways',
      'Bowsprit',
      'HullTreatment',
      'BathingLadder',
      'CockpitLockers',
      'RemovableFootChocks',
      'RemovableCockpitTable',
      'RemovableCompass',
      'Sprayhood',
      'MastAndBoom',
      'BoomCover',
      'Mainsail'
    ]
    data.push(
      exteriorOrder.map(key => {
        const item = exterior[key]
        return item && typeof item.value !== 'undefined' ? item.value : null
      })
    )

    // Transom (Name and Port)
    data.push([])
    data[data.length - 1].push([])
    data[data.length - 1].push([])

    const transom = this.state.transom
    data[data.length - 1][0].push(transom.Name.value)
    data[data.length - 1][0].push(transom.Name.font.value)
    data[data.length - 1][0].push(transom.Name.size.value)
    data[data.length - 1][0].push(transom.Name.color.value)
    data[data.length - 1][0].push(transom.Name.horizontalOffset)
    data[data.length - 1][0].push(transom.Name.verticalOffset)

    data[data.length - 1][1].push(transom.Port.value)
    data[data.length - 1][1].push(transom.Port.font.value)
    data[data.length - 1][1].push(transom.Port.size.value)
    data[data.length - 1][1].push(transom.Port.color.value)
    data[data.length - 1][1].push(transom.Port.horizontalOffset)
    data[data.length - 1][1].push(transom.Port.verticalOffset)

    // Interior options
    const interior = this.state.interior
    const interiorOrder = ['Layout', 'Fabric', 'FabricOwners']
    data.push(
      interiorOrder.map(key => {
        const item = interior[key]
        return item && typeof item.value !== 'undefined' ? item.value : null
      })
    )

    var json = JSON.stringify(data)
    return btoa(json)
  }

  parseCode (code) {
    let json = JSON.parse(atob(code))

    if (json[0] !== 'Xr41') {
      return
    }

    // See generateCode for schema and index order.

    // Exterior
    const exterior = this.state.exterior
    exterior.HullColorways =
      this.HullColourOptions.find(v => v.value === json[1][0]) ||
      this.HullColourOptions[0]
    exterior.Bowsprit =
      this.BowspritOptions.find(v => v.value === json[1][1]) ||
      this.BowspritOptions[0]
    exterior.HullTreatment =
      this.HullTreatmentOptions.find(v => v.value === json[1][2]) ||
      this.HullTreatmentOptions[0]
    exterior.BathingLadder =
      this.BathingLadderOptions.find(v => v.value === json[1][3]) ||
      this.BathingLadderOptions[0]
    exterior.CockpitLockers =
      this.CockpitLockersOptions.find(v => v.value === json[1][4]) ||
      this.CockpitLockersOptions[0]
    exterior.RemovableFootChocks =
      this.RemovableFootChocksOptions.find(v => v.value === json[1][5]) ||
      this.RemovableFootChocksOptions[0]
    exterior.RemovableCockpitTable =
      this.RemovableCockpitTableOptions.find(v => v.value === json[1][6]) ||
      this.RemovableCockpitTableOptions[0]
    exterior.RemovableCompass =
      this.RemovableCompassOptions.find(v => v.value === json[1][7]) ||
      this.RemovableCompassOptions[0]
    exterior.Sprayhood =
      this.SprayhoodOptions.find(v => v.value === json[1][8]) ||
      this.SprayhoodOptions[0]
    exterior.MastAndBoom =
      this.MastAndBoomOptions.find(v => v.value === json[1][9]) ||
      this.MastAndBoomOptions[0]
    exterior.BoomCover =
      this.BoomCoverOptions.find(v => v.value === json[1][10]) ||
      this.BoomCoverOptions[0]
    exterior.Mainsail =
      this.MainsailOptions.find(v => v.value === json[1][11]) ||
      this.MainsailOptions[0]

    // Transom
    const transom = this.state.transom
    transom.Name.value = json[2][0][0] || ''
    transom.Name.font =
      this.fontOptions.find(v => v.value === json[2][0][1]) ||
      this.fontOptions[0]
    transom.Name.size =
      this.sizeOptions.find(v => v.value === json[2][0][2]) ||
      this.sizeOptions[0]
    transom.Name.color =
      this.colorOptions.find(v => v.value === json[2][0][3]) ||
      this.colorOptions[0]
    transom.Name.horizontalOffset = +json[2][0][4] || 1
    transom.Name.verticalOffset = +json[2][0][5] || 1

    transom.Port.value = json[2][1][0] || ''
    transom.Port.font =
      this.fontOptions.find(v => v.value === json[2][1][1]) ||
      this.fontOptions[0]
    transom.Port.size =
      this.sizeOptions.find(v => v.value === json[2][1][2]) ||
      this.sizeOptions[0]
    transom.Port.color =
      this.colorOptions.find(v => v.value === json[2][1][3]) ||
      this.colorOptions[0]
    transom.Port.horizontalOffset = +json[2][1][4] || 1
    transom.Port.verticalOffset = +json[2][1][5] || 1

    // Interior
    const interior = this.state.interior
    interior.Layout =
      this.LayoutOptions.find(v => v.value === json[3][0]) ||
      this.LayoutOptions[0]
    interior.Fabric =
      this.FabricOptions.find(v => v.value === json[3][1]) ||
      this.FabricOptions[0]
    interior.FabricOwners =
      this.FabricOwnersOptions.find(v => v.value === json[3][2]) ||
      this.FabricOwnersOptions[0]

    const parsedFabricValue = interior.Fabric
      ? interior.Fabric.value
      : interior.FabricOwners && interior.FabricOwners.value
    const syncedParsedFabric =
      this.FabricOptions.find(v => v.value === parsedFabricValue) ||
      this.FabricOptions[0]
    interior.Fabric = syncedParsedFabric
    interior.FabricOwners = syncedParsedFabric

    this.setState(this.state)
  }

  renderSteps () {
    return (
      <Switch location={this.props.location}>
        <Route exact path='/xr41' render={() => <Redirect to='/xr41/hull' />} />
        <Route
          path='/xr41/hull'
          render={props => (
            <Xr41Hull
              {...props}
              onChange={this.handleHullConfigurationChange}
              onCodeSubmitted={this.parseCode}
              transom={this.state.transom}
              configuration={this.state.exterior}
              hullColourOptions={this.HullColourOptions}
            />
          )}
        />
        <Route
          path='/xr41/bowsprit'
          render={props => (
            <Xr41BowSprit
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              bowSpritOptions={this.BowspritOptions}
            />
          )}
        />
        <Route
          path='/xr41/hulltreatment'
          render={props => (
            <Xr41HullTreatment
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              hullTreatmentOptions={this.HullTreatmentOptions}
            />
          )}
        />
        <Route
          path='/xr41/boatname'
          render={props => (
            <Xr41Transom
              {...props}
              onChange={this.handleTransomChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              fontOptions={this.fontOptions}
              sizeOptions={this.sizeOptions}
              colorOptions={this.colorOptions}
            />
          )}
        />
        <Route
          path='/xr41/bathingladder'
          render={props => (
            <Xr41BathingLadder
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              bathingLadderOptions={this.BathingLadderOptions}
            />
          )}
        />
        <Route
          path='/xr41/cockpit'
          render={props => (
            <Xr41Cockpit
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              cockpitLockersOptions={this.CockpitLockersOptions}
              removableFootChocksOptions={this.RemovableFootChocksOptions}
              removableCockpitTableOptions={this.RemovableCockpitTableOptions}
              removableCompassOptions={this.RemovableCompassOptions}
            />
          )}
        />
        <Route
          path='/xr41/sprayhood'
          render={props => (
            <Xr41Sprayhood
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              sprayhoodOptions={this.SprayhoodOptions}
              mastAndBoomOptions={this.MastAndBoomOptions}
              boomCoverOptions={this.BoomCoverOptions}
            />
          )}
        />
        <Route
          path='/xr41/mainsail'
          render={props => (
            <Xr41Mainsail
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              mainsailOptions={this.MainsailOptions}
            />
          )}
        />
        <Route
          path='/xr41/saloon'
          render={props => (
            <Xr41Saloon
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              LayoutOptions={this.LayoutOptions}
              FabricOptions={this.FabricOptions}
            />
          )}
        />
        <Route
          path='/xr41/fabric'
          render={props => (
            <Xr41Fabric
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              LayoutOptions={this.LayoutOptions}
              FabricOptions={this.FabricOptions}
            />
          )}
        />
        <Route
          path='/xr41/galley'
          render={props => (
            <Xr41Galley
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              LayoutOptions={this.LayoutOptions}
            />
          )}
        />
        <Route
          path='/xr41/aftcabin'
          render={props => (
            <Xr41Aftcabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              FabricOptions={this.FabricOptions}
            />
          )}
        />
        <Route
          path='/xr41/head'
          render={props => (
            <Xr41Head
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              LayoutOptions={this.LayoutOptions}
            />
          )}
        />
        <Route
          path='/xr41/forwardcabin'
          render={props => (
            <Xr41Forwardcabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              FabricOwnersOptions={this.FabricOwnersOptions}
            />
          )}
        />
        <Route
          path='/xr41/summary'
          render={props => (
            <Xr41Summary
              {...props}
              country={this.state.country}
              countries={this.state.countries}
              code={this.generateCode()}
              configuration={{
                exterior: this.state.exterior,
                interior: this.state.interior,
                transom: this.state.transom
              }}
            />
          )}
        />
      </Switch>
    )
  }
}

export default withTranslation()(Xr41Container)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41Container.js